import { render } from "./templates-lattice.vue?vue&type=template&id=4dec06a0&lang=pug"
import script from "./templates-lattice.vue?vue&type=script&lang=js"
export * from "./templates-lattice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__